import axios from '../axios.js';

var api = {
  //考试入门介绍
  examIntroduce(){
    return axios.post('index/about/introduction')
  },
  //各科学习指南
  studyGuide(params){
    return axios.post('index/about/subject',params)
  },
  //最高学院分享
  mostShare(params){
    return axios.post('index/share/list',params)
  },
  //收藏
  collect(params){
    return axios.post('index/share/collection',params)
  },
  //最强王炸资料
  mostDatas(){
    return axios.post('index/share/material')
  },
  //分享资料详情
  shareInfoText(params){
    return axios.post('index/share/detail',params)
  },
  //浏览量
  lookScore(params){
    return axios.post('index/share/view',params)
  },
  //创始之声
  studyGuideeee(){
    return axios.post('index/about/founding')
  },
}

export default api



// WEBPACK FOOTER //
// ./src/api/aboutGMAT.js